import { c as _c } from "react/compiler-runtime";
import React from "react";
import elements from "./PointList.module.scss";
import { PointListPoint } from "./PointListPoint";
type PointListProps = {
  points: {
    heading: string;
    paragraph: string;
  }[];
  numbered?: boolean;
  options?: {
    layout?: "left" | "top";
  };
};
export const PointList: React.FC<PointListProps> = t0 => {
  const $ = _c(13);
  const {
    points,
    options,
    numbered
  } = t0;
  const layout = options?.layout || "left";
  let classes;
  if ($[0] !== layout || $[1] !== points.length) {
    classes = [elements.pointlistwrapper];
    if (layout === "top") {
      classes.push(elements.top);
    }
    if (points.length > 12) {
      classes.push(elements.autogrid);
    }
    $[0] = layout;
    $[1] = points.length;
    $[2] = classes;
  } else {
    classes = $[2];
  }
  const t1 = classes.join(" ");
  let t2;
  if ($[3] !== layout || $[4] !== numbered || $[5] !== points) {
    let t3;
    if ($[7] !== layout || $[8] !== numbered) {
      t3 = (point, index) => <PointListPoint key={`${index}-${point.heading}`} number={numbered ? index + 1 : undefined} heading={point.heading} paragraph={point.paragraph} layout={layout} />;
      $[7] = layout;
      $[8] = numbered;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    t2 = points.map(t3);
    $[3] = layout;
    $[4] = numbered;
    $[5] = points;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[10] !== t1 || $[11] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};